import { Footer } from "./Components/HeaderFooter/Footer";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./Pages/Home";
import AdvancedTechnology from "./Pages/About/AdvancedTechnology";
import AffordableTreat from "./Pages/About/AffordableTreat";
import Introduction from "./Pages/About/Introduction";
import PersonalizedCare from "./Pages/About/PersonalizedCare";
import QualityExpertise from "./Pages/About/QualityExpertise";
import RightEnvironment from "./Pages/About/RightEnvironment";
import OurKeyWords from "./Pages/About/OurKeyWords";
import Appointment from "./Pages/Appointment";
import Contact from "./Pages/Contact";
import Doctor from "./Pages/Doctor";
import LaparoscopyHysteroscopy from "./Pages/Services/LaparoscopyHysteroscopy";
import WomenHealthCare from "./Pages/Services/WomenHealthCare";
import FertilityCounselling from "./Pages/Services/FertilityCounselling";
import HormonalAssays from "./Pages/Services/HormonalAssays";
import FollicularMonitoring from "./Pages/Services/FollicularMonitoring";
import MaleInfertility from "./Pages/Services/MaleInfertility";
import ObstetricCare from "./Pages/Services/ObstetricCare";
import UrinaryIncontinenceManagement from "./Pages/Services/UrinaryIncontinenceManagement";
import FAQ from "./Pages/FAQ";
import Programe from "./Pages/Programe";
import Headroom from "react-headroom";
import ScrollToTop from "./Components/ScrollToTop";
import BackToTopButton from "./Components/BackToTopButton";
import { useEffect, useState } from "react";
import PreLoader from "./Components/PreLoader";
import { AnimatePresence } from "framer-motion";

import "./responsive.scss";
import Navbar2 from "./Components/HeaderFooter/Navbar2";
import ICSITab from "./Components/Programe/Tabs/ICSITab";
import PRPTab from "./Components/Programe/Tabs/PRPTab";
import IUITab from "./Components/Programe/Tabs/IUITab";
import EmbryoTransferTab from "./Components/Programe/Tabs/EmbryoTransferTab";
import AssistedHechingTab from "./Components/Programe/Tabs/AssistedHechingTab";
import PGSTab from "./Components/Programe/Tabs/PGSTab";
import MACSTab from "./Components/Programe/Tabs/MACSTab";
import GamateDonarsTab from "./Components/Programe/Tabs/GamateDonarsTab";
import SemenCryopreservationTab from "./Components/Programe/Tabs/SemenCryopreservationTab";
import EmbryoCryopreservationTab from "./Components/Programe/Tabs/EmbryoCryopreservationTab";
import ForeignPatientCareTab from "./Components/Programe/Tabs/ForeignPatientCareTab";
import SingleEmbryoTransferTab from "./Components/Programe/Tabs/SingleEmbryoTransferTab";
import LaserAssistedHatchingTab from "./Components/Programe/Tabs/LaserAssistedHatchingTab";
import OocyteFreezingTab from "./Components/Programe/Tabs/OocyteFreezingTab";
import PICSITab from "./Components/Programe/Tabs/PICSITab";
import BlogPage from "./Pages/BlogPage";
import Blog1 from "./Components/Blogs/BlogPages/Blog1";
import Blog2 from "./Components/Blogs/BlogPages/Blog2";
import Blog3 from "./Components/Blogs/BlogPages/Blog3";
import Blog4 from "./Components/Blogs/BlogPages/Blog4";
import Blog5 from "./Components/Blogs/BlogPages/Blog5";
import Blog6 from "./Components/Blogs/BlogPages/Blog6";
import Blog7 from "./Components/Blogs/BlogPages/Blog7";
import { Helmet } from "react-helmet";
import logo from "./Assets/images/icons/logo.png";
import Blog8 from "./Components/Blogs/BlogPages/Blog8";
import Blog9 from "./Components/Blogs/BlogPages/Blog9";
import Blog10 from "./Components/Blogs/BlogPages/Blog10";
import Blog11 from "./Components/Blogs/BlogPages/Blog11";
import Blog12 from "./Components/Blogs/BlogPages/Blog12";
import Blog13 from "./Components/Blogs/BlogPages/Blog13";
import Blog14 from "./Components/Blogs/BlogPages/Blog14";
import Blog15 from "./Components/Blogs/BlogPages/Blog15";
import Blog16 from "./Components/Blogs/BlogPages/Blog16";
import Blog17 from "./Components/Blogs/BlogPages/Blog17";
import Blog18 from "./Components/Blogs/BlogPages/Blog18";
import Blog19 from "./Components/Blogs/BlogPages/Blog19";
import Blog20 from "./Components/Blogs/BlogPages/Blog20";
import Blog21 from "./Components/Blogs/BlogPages/Blog21";
import Blog22 from "./Components/Blogs/BlogPages/Blog22";
import Blog23 from "./Components/Blogs/BlogPages/Blog23";
import Blog24 from "./Components/Blogs/BlogPages/Blog24";
import Blog25 from "./Components/Blogs/BlogPages/Blog25";
import Blog26 from "./Components/Blogs/BlogPages/Blog26";
import Blog27 from "./Components/Blogs/BlogPages/Blog27";
import Blog28 from "./Components/Blogs/BlogPages/Blog28";
import Blog29 from "./Components/Blogs/BlogPages/Blog29";
import Blog30 from "./Components/Blogs/BlogPages/Blog30";
import Blog31 from "./Components/Blogs/BlogPages/Blog31";
import Blog32 from "./Components/Blogs/BlogPages/Blog32";
import Blog33 from "./Components/Blogs/BlogPages/Blog33";
import Blog34 from "./Components/Blogs/BlogPages/Blog34";
import Blog35 from "./Components/Blogs/BlogPages/Blog35";
import Blog36 from "./Components/Blogs/BlogPages/Blog36";

function App() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);
  return isLoading ? (
    <PreLoader />
  ) : (
    <>
      <Helmet>
        <link rel="icon" href={logo} />
      </Helmet>
      <ScrollToTop />
      <Headroom>
        <Navbar2/>
      </Headroom>
      <AnimatePresence mode="wait">
        <Routes basename="/" location={location} key={location.pathname}>
          <Route path="/" index element={<Home />} />

          <Route path="/AdvancedTechnology" element={<AdvancedTechnology />} />
          <Route path="/AffordableTreatment" element={<AffordableTreat />} />
          <Route path="/Introduction" element={<Introduction />} />
          <Route path="/PersonalizedCare" element={<PersonalizedCare />} />
          <Route path="/QualityExpertise" element={<QualityExpertise />} />
          <Route path="/RightEnvironment" element={<RightEnvironment />} />
          <Route path="/OurKeyWords" element={<OurKeyWords />} />

          <Route path="/Appointment" element={<Appointment />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Doctor" element={<Doctor />} />

          <Route
            path="/LaparoscopyHysteroscopy"
            element={<LaparoscopyHysteroscopy />}
          />
          <Route path="/WomenHealthCare" element={<WomenHealthCare />} />
          <Route
            path="/FertilityCounselling"
            element={<FertilityCounselling />}
          />
          <Route path="/HormonalAssays" element={<HormonalAssays />} />
          <Route
            path="/FollicularMonitoring"
            element={<FollicularMonitoring />}
          />
          <Route path="/MaleInfertility" element={<MaleInfertility />} />
          <Route path="/ObstetricCare" element={<ObstetricCare />} />
          <Route
            path="/UrinaryIncontinenceManagement"
            element={<UrinaryIncontinenceManagement />}
          />

          <Route path="/FAQ" element={<FAQ />} />

          <Route path="/Programme/IVF" element={<Programe />} />

          <Route path="/Programme/ICSI" element={<ICSITab />} />
          <Route path="/Programme/PRP" element={<PRPTab />} />
          <Route path="/Programme/IUI" element={<IUITab />} />
          <Route
            path="/Programme/EmbryoTransfer"
            element={<EmbryoTransferTab />}
          />
          <Route
            path="/Programme/AssistedHeching"
            element={<AssistedHechingTab />}
          />
          <Route path="/Programme/PGS" element={<PGSTab />} />
          <Route path="/Programme/MACS" element={<MACSTab />} />
          <Route path="/Programme/GamateDonars" element={<GamateDonarsTab />} />
          <Route
            path="/Programme/SemenCryopreservation"
            element={<SemenCryopreservationTab />}
          />
          <Route
            path="/Programme/EmbryoCryopreservation"
            element={<EmbryoCryopreservationTab />}
          />
          <Route
            path="/Programme/ForeignPatientCare"
            element={<ForeignPatientCareTab />}
          />
          <Route
            path="/Programme/SingleEmbryoTransfer"
            element={<SingleEmbryoTransferTab />}
          />
          <Route
            path="/Programme/LaserAssistedHatching"
            element={<LaserAssistedHatchingTab />}
          />
          <Route
            path="/Programme/OocyteFreezing"
            element={<OocyteFreezingTab />}
          />
          <Route path="/Programme/PICSI" element={<PICSITab />} />

          <Route path="/Blogs" element={<BlogPage />} />
          <Route path="/1/BlogDetails" element={<Blog1 />} />
          <Route path="/2/BlogDetails" element={<Blog2 />} />
          <Route path="/3/BlogDetails" element={<Blog3 />} />
          <Route path="/4/BlogDetails" element={<Blog4 />} />
          <Route path="/5/BlogDetails" element={<Blog5 />} />
          <Route path="/6/BlogDetails" element={<Blog6 />} />
          <Route path="/7/BlogDetails" element={<Blog7 />} />
          <Route path="/8/BlogDetails" element={<Blog8 />} />
          <Route path="/9/BlogDetails" element={<Blog9 />} />
          <Route path="/10/BlogDetails" element={<Blog10 />} />
          <Route path="/11/BlogDetails" element={<Blog11 />} />
          <Route path="/12/BlogDetails" element={<Blog12 />} />
          <Route path="/13/BlogDetails" element={<Blog13 />} />

          <Route path="/14/BlogDetails" element={<Blog14 />} />
          <Route path="/15/BlogDetails" element={<Blog15 />} />
          <Route path="/16/BlogDetails" element={<Blog16 />} />
          <Route
            path="/17/ivf-specialist-in-chembur-mumbai"
            element={<Blog17 />}
          />
          <Route path="/18/trusted-ivf-centre-in-mumbai" element={<Blog18 />} />
          <Route
            path="/19/choose-an-ivf-center-in-mumbai"
            element={<Blog19 />}
          />
          <Route
            path="/20/7-proven-reasons-acme-fertility"
            element={<Blog20 />}
          />
          <Route
            path="/21/best-gynecologist-hospital-in-chembur"
            element={<Blog21 />}
          />
          <Route
            path="/22/7-proven-reasons-to-choose-fertility-clinic"
            element={<Blog22 />}
          />
          <Route
            path="/23/Best-Infertility-Specialist-in-Mumbai"
            element={<Blog23 />}
          />
          <Route
            path="/24/Best-IVF-Clinic-in-Mumbai-in-2026"
            element={<Blog24 />}
          />
          <Route
            path="/25/5-Powerful-Reasons-Why-Couples-Choose-IVF-for-Successful-Parenthood"
            element={<Blog25 />}
          />
          <Route
            path="/26/7-Reasons-Acme-Fertility-Is-the-Top-IVF-Hospital-in-Mumbai-for-Higher-Success-Rates"
            element={<Blog26 />}
          />
          <Route
            path="/27/Gynecologist-Hospital-in-Chembur:-Expert-Women's-Healthcare-&-Fertility-Care"
            element={<Blog27 />}
          />
          <Route
            path="/28/IVF-Success-Rates-in-India:Proven-2026-Guide"
            element={<Blog28 />}
          />
          <Route
            path="/29/Myths-and-Facts-About-Infertility-Treatment-(2026 Guide)"
            element={<Blog29 />}
          />
          <Route
            path="/30/Best Fertility Clinic in Mumbai | Trusted IVF Center 2026"
            element={<Blog30 />}
          />
          <Route
            path="/31/Facts About Fertility Clinic Near Me: IVF, IUI, ICSI & Other Treatment Options Explained (2026)"
            element={<Blog31 />}
          />
          <Route
            path="/32/Best-Infertility-Specialist-in-Mumbai-Dr-Neelam-Bhise"
            element={<Blog32 />}
          />
          <Route
            path="/33/7-Crucial-Facts-About-IVF-Cost-in-Mumbai-and-Chembur"
            element={<Blog33 />}
          />
             <Route
            path="/34/5-Smart-Insights-on-IUI-Cost-vs-IVF-Cost"
            element={<Blog34 />}
          />
          <Route
            path="/35/Does-Health-Insurance-Cover-IVF-in-India?"
            element={<Blog35 />}
          />
           <Route
            path="/36/10-Essential-Low-Sperm-Count-Signs"
            element={<Blog36 />}
          />
        </Routes>
      </AnimatePresence>
      <Footer />
      <BackToTopButton />
    </>
  );
}

export default App;
